export enum CategoryIcon {
    Exterior = "car",
    Interior = "interior_car",
}

export type CategoryIconType = CategoryIcon.Exterior | CategoryIcon.Interior;
